"use strict";function t(o,e){return t=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,o){return t.__proto__=o,t},t(o,e)}exports._inheritsLoose=function(o,e){o.prototype=Object.create(e.prototype),o.prototype.constructor=o,t(o,e)};
//# sourceMappingURL=inheritsLoose-490721fe.js.map
